// @ts-nocheck -- generated; see web/scripts/generate-client.ts
// Do not edit. Regenerate with `pnpm -C web generate:client`.
// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, AcceptLegalDocumentsData, AcceptLegalDocumentsErrors, AcceptLegalDocumentsResponses, AcceptPasswordResetData, AcceptPasswordResetErrors, AcceptPasswordResetResponses, ActivateStrategyAllocationData, ActivateStrategyAllocationErrors, ActivateStrategyAllocationResponses, AssignStrategyAllocationData, AssignStrategyAllocationErrors, AssignStrategyAllocationResponses, CancelExitData, CancelExitErrors, CancelExitResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ChoosePoolSelectionData, ChoosePoolSelectionErrors, ChoosePoolSelectionResponses, ConnectBybitAccountData, ConnectBybitAccountErrors, ConnectBybitAccountResponses, CreateInvitationData, CreateInvitationErrors, CreateInvitationResponses, CreateOwnAccountData, CreateOwnAccountErrors, CreateOwnAccountResponses, CreatePlatformClientData, CreatePlatformClientErrors, CreatePlatformClientResponses, DecideReferralPayoutData, DecideReferralPayoutErrors, DecideReferralPayoutResponses, DisconnectBybitAccountData, DisconnectBybitAccountErrors, DisconnectBybitAccountResponses, DraftPlatformRevisionData, DraftPlatformRevisionErrors, DraftPlatformRevisionResponses, GetBybitConnectionData, GetBybitConnectionResponses, GovernStrategyVersionData, GovernStrategyVersionErrors, GovernStrategyVersionResponses, HealthLiveData, HealthLiveResponses, HealthReadyData, HealthReadyResponses, HealthSafeData, HealthSafeResponses, IssueClientPasswordResetData, IssueClientPasswordResetErrors, IssueClientPasswordResetResponses, JoinByInvitationData, JoinByInvitationErrors, JoinByInvitationResponses, LaunchExitData, LaunchExitErrors, LaunchExitResponses, ListConformanceRunsData, ListConformanceRunsErrors, ListConformanceRunsResponses, PauseClientAccountData, PauseClientAccountErrors, PauseClientAccountResponses, PublishPlatformRevisionData, PublishPlatformRevisionErrors, PublishPlatformRevisionResponses, ReadAccountRegistryData, ReadAccountRegistryResponses, ReadAnalyticsData, ReadAnalyticsErrors, ReadAnalyticsResponses, ReadClientAccountData, ReadClientAccountResponses, ReadConformanceRunData, ReadConformanceRunErrors, ReadConformanceRunResponses, ReadExitSimulationData, ReadExitSimulationErrors, ReadExitSimulationResponses, ReadFeeBalanceData, ReadFeeBalanceErrors, ReadFeeBalanceResponses, ReadHistoryData, ReadHistoryErrors, ReadHistoryResponses, ReadInvitationData, ReadInvitationErrors, ReadInvitationResponses, ReadLegalDocumentsData, ReadLegalDocumentsResponses, ReadOverviewData, ReadOverviewErrors, ReadOverviewResponses, ReadOwnInvitationData, ReadOwnInvitationErrors, ReadOwnInvitationResponses, ReadPlatformClientOperationsData, ReadPlatformClientOperationsErrors, ReadPlatformClientOperationsResponses, ReadPlatformClientsData, ReadPlatformClientsResponses, ReadPlatformRankingData, ReadPlatformRankingErrors, ReadPlatformRankingResponses, ReadPlatformRegistryData, ReadPlatformRegistryResponses, ReadPoolSelectionData, ReadPoolSelectionResponses, ReadRankingData, ReadRankingErrors, ReadRankingResponses, ReadReferralData, ReadReferralErrors, ReadReferralPayoutsData, ReadReferralPayoutsErrors, ReadReferralPayoutsResponses, ReadReferralResponses, ReadReleaseConformanceData, ReadReleaseConformanceResponses, ReadReleaseStatusData, ReadReleaseStatusErrors, ReadReleaseStatusResponses, ReadRiskData, ReadRiskResponses, ReadSameEntrySimulatorExperimentData, ReadSameEntrySimulatorExperimentErrors, ReadSameEntrySimulatorExperimentResponses, ReadScopesData, ReadScopesErrors, ReadScopesResponses, ReadScoreDecisionExplanationData, ReadScoreDecisionExplanationErrors, ReadScoreDecisionExplanationResponses, ReadScorePolicyData, ReadScorePolicyDiffData, ReadScorePolicyDiffErrors, ReadScorePolicyDiffResponses, ReadScorePolicyErrors, ReadScorePolicyHistoryData, ReadScorePolicyHistoryErrors, ReadScorePolicyHistoryResponses, ReadScorePolicyResponses, ReadScoreRecommendationsData, ReadScoreRecommendationsResponses, ReadSessionData, ReadSessionErrors, ReadSessionResponses, ReadSlotCandlesData, ReadSlotCandlesErrors, ReadSlotCandlesResponses, ReadStrategiesData, ReadStrategiesResponses, ReadStrategyAllocationsData, ReadStrategyAllocationsResponses, ReadStrategyComparisonData, ReadStrategyComparisonResponses, ReadStrategyReadinessData, ReadStrategyReadinessResponses, ReadStrategyWorkspaceData, ReadStrategyWorkspaceResponses, ReadSystemData, ReadSystemErrors, ReadSystemResponses, ReadTelegramLinkData, ReadTelegramLinkResponses, ReadTradingControlData, ReadTradingControlResponses, ReadUnattributedFeeDepositsData, ReadUnattributedFeeDepositsErrors, ReadUnattributedFeeDepositsResponses, RequestReferralPayoutData, RequestReferralPayoutErrors, RequestReferralPayoutResponses, RequestTradingStartData, RequestTradingStartErrors, RequestTradingStartResponses, ReturnWithheldProfitData, ReturnWithheldProfitErrors, ReturnWithheldProfitResponses, RunQuickConformanceData, RunQuickConformanceResponses, SetClientReinvestmentData, SetClientReinvestmentErrors, SetClientReinvestmentResponses, SetClientTimeRecoveryData, SetClientTimeRecoveryErrors, SetClientTimeRecoveryResponses, SetPlatformClientFeeData, SetPlatformClientFeeErrors, SetPlatformClientFeeResponses, SetPlatformClientReferrerData, SetPlatformClientReferrerErrors, SetPlatformClientReferrerResponses, SignInData, SignInErrors, SignInResponses, SignOutData, SignOutResponses, StartFullConformanceData, StartFullConformanceResponses, StartTelegramLinkData, StartTelegramLinkErrors, StartTelegramLinkResponses, SwitchScopeData, SwitchScopeErrors, SwitchScopeResponses, UnlinkTelegramData, UnlinkTelegramErrors, UnlinkTelegramResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Read Client Account
 */
export const readClientAccount = <ThrowOnError extends boolean = false>(options?: Options<ReadClientAccountData, ThrowOnError>): RequestResult<ReadClientAccountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadClientAccountResponses, unknown, ThrowOnError>({ url: '/api/account', ...options });

/**
 * Read Account Fee Balance
 */
export const readFeeBalance = <ThrowOnError extends boolean = false>(options?: Options<ReadFeeBalanceData, ThrowOnError>): RequestResult<ReadFeeBalanceResponses, ReadFeeBalanceErrors, ThrowOnError> => (options?.client ?? client).get<ReadFeeBalanceResponses, ReadFeeBalanceErrors, ThrowOnError>({ url: '/api/account/fee-balance', ...options });

/**
 * Pause Client Account
 */
export const pauseClientAccount = <ThrowOnError extends boolean = false>(options: Options<PauseClientAccountData, ThrowOnError>): RequestResult<PauseClientAccountResponses, PauseClientAccountErrors, ThrowOnError> => (options.client ?? client).post<PauseClientAccountResponses, PauseClientAccountErrors, ThrowOnError>({
    url: '/api/account/pause',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Pool Selection
 */
export const readPoolSelection = <ThrowOnError extends boolean = false>(options?: Options<ReadPoolSelectionData, ThrowOnError>): RequestResult<ReadPoolSelectionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadPoolSelectionResponses, unknown, ThrowOnError>({ url: '/api/account/pools', ...options });

/**
 * Choose Pool Selection
 */
export const choosePoolSelection = <ThrowOnError extends boolean = false>(options: Options<ChoosePoolSelectionData, ThrowOnError>): RequestResult<ChoosePoolSelectionResponses, ChoosePoolSelectionErrors, ThrowOnError> => (options.client ?? client).post<ChoosePoolSelectionResponses, ChoosePoolSelectionErrors, ThrowOnError>({
    url: '/api/account/pools',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Account Referral
 */
export const readReferral = <ThrowOnError extends boolean = false>(options?: Options<ReadReferralData, ThrowOnError>): RequestResult<ReadReferralResponses, ReadReferralErrors, ThrowOnError> => (options?.client ?? client).get<ReadReferralResponses, ReadReferralErrors, ThrowOnError>({ url: '/api/account/referral', ...options });

/**
 * Request Referral Payout
 *
 * Ask the owner to pay the referral credit out in USDT by Bybit UID.
 */
export const requestReferralPayout = <ThrowOnError extends boolean = false>(options?: Options<RequestReferralPayoutData, ThrowOnError>): RequestResult<RequestReferralPayoutResponses, RequestReferralPayoutErrors, ThrowOnError> => (options?.client ?? client).post<RequestReferralPayoutResponses, RequestReferralPayoutErrors, ThrowOnError>({ url: '/api/account/referral/payout', ...options });

/**
 * Set Client Reinvestment
 */
export const setClientReinvestment = <ThrowOnError extends boolean = false>(options: Options<SetClientReinvestmentData, ThrowOnError>): RequestResult<SetClientReinvestmentResponses, SetClientReinvestmentErrors, ThrowOnError> => (options.client ?? client).post<SetClientReinvestmentResponses, SetClientReinvestmentErrors, ThrowOnError>({
    url: '/api/account/reinvestment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return Withheld Profit
 *
 * «Добавить к капиталу»: profit set aside for withdrawal goes back to work.
 */
export const returnWithheldProfit = <ThrowOnError extends boolean = false>(options: Options<ReturnWithheldProfitData, ThrowOnError>): RequestResult<ReturnWithheldProfitResponses, ReturnWithheldProfitErrors, ThrowOnError> => (options.client ?? client).post<ReturnWithheldProfitResponses, ReturnWithheldProfitErrors, ThrowOnError>({
    url: '/api/account/reinvestment/return',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Client Time Recovery
 */
export const setClientTimeRecovery = <ThrowOnError extends boolean = false>(options: Options<SetClientTimeRecoveryData, ThrowOnError>): RequestResult<SetClientTimeRecoveryResponses, SetClientTimeRecoveryErrors, ThrowOnError> => (options.client ?? client).post<SetClientTimeRecoveryResponses, SetClientTimeRecoveryErrors, ThrowOnError>({
    url: '/api/account/time-recovery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Trading Control
 */
export const readTradingControl = <ThrowOnError extends boolean = false>(options?: Options<ReadTradingControlData, ThrowOnError>): RequestResult<ReadTradingControlResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadTradingControlResponses, unknown, ThrowOnError>({ url: '/api/account/trading', ...options });

/**
 * Request Start
 *
 * Ask the execution side to start the account; it decides within a minute.
 */
export const requestTradingStart = <ThrowOnError extends boolean = false>(options: Options<RequestTradingStartData, ThrowOnError>): RequestResult<RequestTradingStartResponses, RequestTradingStartErrors, ThrowOnError> => (options.client ?? client).post<RequestTradingStartResponses, RequestTradingStartErrors, ThrowOnError>({
    url: '/api/account/trading/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Connection Status
 */
export const getBybitConnection = <ThrowOnError extends boolean = false>(options?: Options<GetBybitConnectionData, ThrowOnError>): RequestResult<GetBybitConnectionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBybitConnectionResponses, unknown, ThrowOnError>({ url: '/api/accounts/bybit', ...options });

/**
 * Connect Account
 */
export const connectBybitAccount = <ThrowOnError extends boolean = false>(options: Options<ConnectBybitAccountData, ThrowOnError>): RequestResult<ConnectBybitAccountResponses, ConnectBybitAccountErrors, ThrowOnError> => (options.client ?? client).post<ConnectBybitAccountResponses, ConnectBybitAccountErrors, ThrowOnError>({
    url: '/api/accounts/bybit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disconnect Account
 */
export const disconnectBybitAccount = <ThrowOnError extends boolean = false>(options: Options<DisconnectBybitAccountData, ThrowOnError>): RequestResult<DisconnectBybitAccountResponses, DisconnectBybitAccountErrors, ThrowOnError> => (options.client ?? client).post<DisconnectBybitAccountResponses, DisconnectBybitAccountErrors, ThrowOnError>({
    url: '/api/accounts/bybit/disconnect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Account performance evidence for one exact period
 *
 * Render Task 3 calculations; transport code performs no financial math.
 */
export const readAnalytics = <ThrowOnError extends boolean = false>(options?: Options<ReadAnalyticsData, ThrowOnError>): RequestResult<ReadAnalyticsResponses, ReadAnalyticsErrors, ThrowOnError> => (options?.client ?? client).get<ReadAnalyticsResponses, ReadAnalyticsErrors, ThrowOnError>({ url: '/api/analytics', ...options });

/**
 * Change one's own password
 *
 * Verify the current password, store the new one, end the other sessions.
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    url: '/api/auth/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Where this person can work
 *
 * The platform, if administered, and the person's own accounts.
 */
export const readScopes = <ThrowOnError extends boolean = false>(options?: Options<ReadScopesData, ThrowOnError>): RequestResult<ReadScopesResponses, ReadScopesErrors, ThrowOnError> => (options?.client ?? client).get<ReadScopesResponses, ReadScopesErrors, ThrowOnError>({ url: '/api/auth/scopes', ...options });

/**
 * Sign out
 *
 * End this session. Signing out without one is not an error.
 *
 * Answers the same way whether or not there was a session: a different
 * answer would let anyone learn whether a stolen cookie is still live.
 */
export const signOut = <ThrowOnError extends boolean = false>(options?: Options<SignOutData, ThrowOnError>): RequestResult<SignOutResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<SignOutResponses, unknown, ThrowOnError>({ url: '/api/auth/session', ...options });

/**
 * Check the session
 *
 * Say whether this browser still holds a session, and until when.
 */
export const readSession = <ThrowOnError extends boolean = false>(options?: Options<ReadSessionData, ThrowOnError>): RequestResult<ReadSessionResponses, ReadSessionErrors, ThrowOnError> => (options?.client ?? client).get<ReadSessionResponses, ReadSessionErrors, ThrowOnError>({ url: '/api/auth/session', ...options });

/**
 * Sign in
 *
 * Exchange the owner password for a session cookie.
 */
export const signIn = <ThrowOnError extends boolean = false>(options: Options<SignInData, ThrowOnError>): RequestResult<SignInResponses, SignInErrors, ThrowOnError> => (options.client ?? client).post<SignInResponses, SignInErrors, ThrowOnError>({
    url: '/api/auth/session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move this session to another of the person's own scopes
 *
 * Reissue the session where the person asked, if it is theirs now.
 */
export const switchScope = <ThrowOnError extends boolean = false>(options: Options<SwitchScopeData, ThrowOnError>): RequestResult<SwitchScopeResponses, SwitchScopeErrors, ThrowOnError> => (options.client ?? client).post<SwitchScopeResponses, SwitchScopeErrors, ThrowOnError>({
    url: '/api/auth/session/scope',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What the strategy actually traded
 *
 * One page of finished cycles, ordered over the whole span.
 */
export const readHistory = <ThrowOnError extends boolean = false>(options?: Options<ReadHistoryData, ThrowOnError>): RequestResult<ReadHistoryResponses, ReadHistoryErrors, ThrowOnError> => (options?.client ?? client).get<ReadHistoryResponses, ReadHistoryErrors, ThrowOnError>({ url: '/api/history', ...options });

/**
 * Read Platform Clients
 */
export const readPlatformClients = <ThrowOnError extends boolean = false>(options?: Options<ReadPlatformClientsData, ThrowOnError>): RequestResult<ReadPlatformClientsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadPlatformClientsResponses, unknown, ThrowOnError>({ url: '/api/identity/clients', ...options });

/**
 * Create Platform Client
 */
export const createPlatformClient = <ThrowOnError extends boolean = false>(options: Options<CreatePlatformClientData, ThrowOnError>): RequestResult<CreatePlatformClientResponses, CreatePlatformClientErrors, ThrowOnError> => (options.client ?? client).post<CreatePlatformClientResponses, CreatePlatformClientErrors, ThrowOnError>({
    url: '/api/identity/clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Platform Client Fee
 */
export const setPlatformClientFee = <ThrowOnError extends boolean = false>(options: Options<SetPlatformClientFeeData, ThrowOnError>): RequestResult<SetPlatformClientFeeResponses, SetPlatformClientFeeErrors, ThrowOnError> => (options.client ?? client).post<SetPlatformClientFeeResponses, SetPlatformClientFeeErrors, ThrowOnError>({
    url: '/api/identity/clients/{tenant_id}/{account_id}/fee',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue Client Password Reset
 *
 * A one-use link for a client who lost the password (owner, 2026-10-14).
 */
export const issueClientPasswordReset = <ThrowOnError extends boolean = false>(options: Options<IssueClientPasswordResetData, ThrowOnError>): RequestResult<IssueClientPasswordResetResponses, IssueClientPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<IssueClientPasswordResetResponses, IssueClientPasswordResetErrors, ThrowOnError>({
    url: '/api/identity/clients/{tenant_id}/{account_id}/password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Platform Client Referrer
 */
export const setPlatformClientReferrer = <ThrowOnError extends boolean = false>(options: Options<SetPlatformClientReferrerData, ThrowOnError>): RequestResult<SetPlatformClientReferrerResponses, SetPlatformClientReferrerErrors, ThrowOnError> => (options.client ?? client).post<SetPlatformClientReferrerResponses, SetPlatformClientReferrerErrors, ThrowOnError>({
    url: '/api/identity/clients/{tenant_id}/{account_id}/referrer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Invitation
 */
export const createInvitation = <ThrowOnError extends boolean = false>(options: Options<CreateInvitationData, ThrowOnError>): RequestResult<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError> => (options.client ?? client).post<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError>({
    url: '/api/identity/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Invitation
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>): RequestResult<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError> => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    url: '/api/identity/invitations/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Invitation
 */
export const readInvitation = <ThrowOnError extends boolean = false>(options: Options<ReadInvitationData, ThrowOnError>): RequestResult<ReadInvitationResponses, ReadInvitationErrors, ThrowOnError> => (options.client ?? client).get<ReadInvitationResponses, ReadInvitationErrors, ThrowOnError>({ url: '/api/identity/join/{code}', ...options });

/**
 * Join By Invitation
 *
 * Only by a client's invitation: the code is the door (owner, 2026-10-29).
 * The newcomer then signs in as any client does.
 */
export const joinByInvitation = <ThrowOnError extends boolean = false>(options: Options<JoinByInvitationData, ThrowOnError>): RequestResult<JoinByInvitationResponses, JoinByInvitationErrors, ThrowOnError> => (options.client ?? client).post<JoinByInvitationResponses, JoinByInvitationErrors, ThrowOnError>({
    url: '/api/identity/join/{code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Own Account
 *
 * The administrator's own trading account, reached by switching scope.
 */
export const createOwnAccount = <ThrowOnError extends boolean = false>(options: Options<CreateOwnAccountData, ThrowOnError>): RequestResult<CreateOwnAccountResponses, CreateOwnAccountErrors, ThrowOnError> => (options.client ?? client).post<CreateOwnAccountResponses, CreateOwnAccountErrors, ThrowOnError>({
    url: '/api/identity/own-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Own Invitation
 *
 * The administrator's own invitation link's code (owner, 2026-10-29).
 */
export const readOwnInvitation = <ThrowOnError extends boolean = false>(options?: Options<ReadOwnInvitationData, ThrowOnError>): RequestResult<ReadOwnInvitationResponses, ReadOwnInvitationErrors, ThrowOnError> => (options?.client ?? client).get<ReadOwnInvitationResponses, ReadOwnInvitationErrors, ThrowOnError>({ url: '/api/identity/own-invitation', ...options });

/**
 * Accept Password Reset
 */
export const acceptPasswordReset = <ThrowOnError extends boolean = false>(options: Options<AcceptPasswordResetData, ThrowOnError>): RequestResult<AcceptPasswordResetResponses, AcceptPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<AcceptPasswordResetResponses, AcceptPasswordResetErrors, ThrowOnError>({
    url: '/api/identity/password-reset/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Referral Payouts
 *
 * Referral credit clients asked to take in USDT (owner, 2026-10-29).
 */
export const readReferralPayouts = <ThrowOnError extends boolean = false>(options?: Options<ReadReferralPayoutsData, ThrowOnError>): RequestResult<ReadReferralPayoutsResponses, ReadReferralPayoutsErrors, ThrowOnError> => (options?.client ?? client).get<ReadReferralPayoutsResponses, ReadReferralPayoutsErrors, ThrowOnError>({ url: '/api/identity/referral-payouts', ...options });

/**
 * Decide Referral Payout
 */
export const decideReferralPayout = <ThrowOnError extends boolean = false>(options: Options<DecideReferralPayoutData, ThrowOnError>): RequestResult<DecideReferralPayoutResponses, DecideReferralPayoutErrors, ThrowOnError> => (options.client ?? client).post<DecideReferralPayoutResponses, DecideReferralPayoutErrors, ThrowOnError>({
    url: '/api/identity/referral-payouts/{payout_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Legal Documents
 */
export const acceptLegalDocuments = <ThrowOnError extends boolean = false>(options: Options<AcceptLegalDocumentsData, ThrowOnError>): RequestResult<AcceptLegalDocumentsResponses, AcceptLegalDocumentsErrors, ThrowOnError> => (options.client ?? client).post<AcceptLegalDocumentsResponses, AcceptLegalDocumentsErrors, ThrowOnError>({
    url: '/api/legal/acceptance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Legal Documents
 */
export const readLegalDocuments = <ThrowOnError extends boolean = false>(options?: Options<ReadLegalDocumentsData, ThrowOnError>): RequestResult<ReadLegalDocumentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadLegalDocumentsResponses, unknown, ThrowOnError>({ url: '/api/legal/documents', ...options });

/**
 * Unlink Telegram
 */
export const unlinkTelegram = <ThrowOnError extends boolean = false>(options?: Options<UnlinkTelegramData, ThrowOnError>): RequestResult<UnlinkTelegramResponses, UnlinkTelegramErrors, ThrowOnError> => (options?.client ?? client).delete<UnlinkTelegramResponses, UnlinkTelegramErrors, ThrowOnError>({ url: '/api/notifications/telegram', ...options });

/**
 * Read Telegram Link
 */
export const readTelegramLink = <ThrowOnError extends boolean = false>(options?: Options<ReadTelegramLinkData, ThrowOnError>): RequestResult<ReadTelegramLinkResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadTelegramLinkResponses, unknown, ThrowOnError>({ url: '/api/notifications/telegram', ...options });

/**
 * Start Telegram Link
 */
export const startTelegramLink = <ThrowOnError extends boolean = false>(options?: Options<StartTelegramLinkData, ThrowOnError>): RequestResult<StartTelegramLinkResponses, StartTelegramLinkErrors, ThrowOnError> => (options?.client ?? client).post<StartTelegramLinkResponses, StartTelegramLinkErrors, ThrowOnError>({ url: '/api/notifications/telegram/link', ...options });

/**
 * What is happening
 *
 * One snapshot of the whole account.
 */
export const readOverview = <ThrowOnError extends boolean = false>(options?: Options<ReadOverviewData, ThrowOnError>): RequestResult<ReadOverviewResponses, ReadOverviewErrors, ThrowOnError> => (options?.client ?? client).get<ReadOverviewResponses, ReadOverviewErrors, ThrowOnError>({ url: '/api/overview', ...options });

/**
 * Launch the full exit the owner was shown
 *
 * The word, then the switch, then the plan: each refusal before any work.
 */
export const launchExit = <ThrowOnError extends boolean = false>(options: Options<LaunchExitData, ThrowOnError>): RequestResult<LaunchExitResponses, LaunchExitErrors, ThrowOnError> => (options.client ?? client).post<LaunchExitResponses, LaunchExitErrors, ThrowOnError>({
    url: '/api/overview/exit-plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop the account's launched exit; new cycles stay paused
 */
export const cancelExit = <ThrowOnError extends boolean = false>(options?: Options<CancelExitData, ThrowOnError>): RequestResult<CancelExitResponses, CancelExitErrors, ThrowOnError> => (options?.client ?? client).post<CancelExitResponses, CancelExitErrors, ThrowOnError>({ url: '/api/overview/exit-plan/cancel', ...options });

/**
 * What a full exit from the capital would cost, cycle by cycle
 */
export const readExitSimulation = <ThrowOnError extends boolean = false>(options?: Options<ReadExitSimulationData, ThrowOnError>): RequestResult<ReadExitSimulationResponses, ReadExitSimulationErrors, ThrowOnError> => (options?.client ?? client).get<ReadExitSimulationResponses, ReadExitSimulationErrors, ThrowOnError>({ url: '/api/overview/exit-simulation', ...options });

/**
 * Price history of an open cycle's symbol
 *
 * Only a symbol this account holds in this slot is ever asked of the venue.
 */
export const readSlotCandles = <ThrowOnError extends boolean = false>(options: Options<ReadSlotCandlesData, ThrowOnError>): RequestResult<ReadSlotCandlesResponses, ReadSlotCandlesErrors, ThrowOnError> => (options.client ?? client).get<ReadSlotCandlesResponses, ReadSlotCandlesErrors, ThrowOnError>({ url: '/api/overview/slots/{slot_id}/candles', ...options });

/**
 * Every client account's operations
 */
export const readPlatformClientOperations = <ThrowOnError extends boolean = false>(options?: Options<ReadPlatformClientOperationsData, ThrowOnError>): RequestResult<ReadPlatformClientOperationsResponses, ReadPlatformClientOperationsErrors, ThrowOnError> => (options?.client ?? client).get<ReadPlatformClientOperationsResponses, ReadPlatformClientOperationsErrors, ThrowOnError>({ url: '/api/platform/clients', ...options });

/**
 * Fee payments from a Bybit UID no client has connected
 */
export const readUnattributedFeeDeposits = <ThrowOnError extends boolean = false>(options?: Options<ReadUnattributedFeeDepositsData, ThrowOnError>): RequestResult<ReadUnattributedFeeDepositsResponses, ReadUnattributedFeeDepositsErrors, ThrowOnError> => (options?.client ?? client).get<ReadUnattributedFeeDepositsResponses, ReadUnattributedFeeDepositsErrors, ThrowOnError>({ url: '/api/platform/fee-deposits/unattributed', ...options });

/**
 * The platform's Skryptos Score window
 *
 * The last window ranked from public market data, for the administrator.
 *
 * Not an account's ranking: no account, no held symbols, no cycle history.
 */
export const readPlatformRanking = <ThrowOnError extends boolean = false>(options?: Options<ReadPlatformRankingData, ThrowOnError>): RequestResult<ReadPlatformRankingResponses, ReadPlatformRankingErrors, ThrowOnError> => (options?.client ?? client).get<ReadPlatformRankingResponses, ReadPlatformRankingErrors, ThrowOnError>({ url: '/api/platform/ranking', ...options });

/**
 * What the strategy is watching
 *
 * The last published window, and how old it is.
 */
export const readRanking = <ThrowOnError extends boolean = false>(options?: Options<ReadRankingData, ThrowOnError>): RequestResult<ReadRankingResponses, ReadRankingErrors, ThrowOnError> => (options?.client ?? client).get<ReadRankingResponses, ReadRankingErrors, ThrowOnError>({ url: '/api/ranking', ...options });

/**
 * Read Risk
 */
export const readRisk = <ThrowOnError extends boolean = false>(options?: Options<ReadRiskData, ThrowOnError>): RequestResult<ReadRiskResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadRiskResponses, unknown, ThrowOnError>({ url: '/api/risk', ...options });

/**
 * Read Strategies
 */
export const readStrategies = <ThrowOnError extends boolean = false>(options?: Options<ReadStrategiesData, ThrowOnError>): RequestResult<ReadStrategiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadStrategiesResponses, unknown, ThrowOnError>({ url: '/api/strategies', ...options });

/**
 * Read Comparison
 */
export const readStrategyComparison = <ThrowOnError extends boolean = false>(options?: Options<ReadStrategyComparisonData, ThrowOnError>): RequestResult<ReadStrategyComparisonResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadStrategyComparisonResponses, unknown, ThrowOnError>({ url: '/api/strategies/comparison', ...options });

/**
 * Read Readiness
 */
export const readStrategyReadiness = <ThrowOnError extends boolean = false>(options?: Options<ReadStrategyReadinessData, ThrowOnError>): RequestResult<ReadStrategyReadinessResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadStrategyReadinessResponses, unknown, ThrowOnError>({ url: '/api/strategies/readiness', ...options });

/**
 * Platform Registry
 */
export const readPlatformRegistry = <ThrowOnError extends boolean = false>(options?: Options<ReadPlatformRegistryData, ThrowOnError>): RequestResult<ReadPlatformRegistryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadPlatformRegistryResponses, unknown, ThrowOnError>({ url: '/api/strategies/registry', ...options });

/**
 * Account Registry
 */
export const readAccountRegistry = <ThrowOnError extends boolean = false>(options?: Options<ReadAccountRegistryData, ThrowOnError>): RequestResult<ReadAccountRegistryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadAccountRegistryResponses, unknown, ThrowOnError>({ url: '/api/strategies/registry/account', ...options });

/**
 * Publish Platform Revision
 */
export const publishPlatformRevision = <ThrowOnError extends boolean = false>(options: Options<PublishPlatformRevisionData, ThrowOnError>): RequestResult<PublishPlatformRevisionResponses, PublishPlatformRevisionErrors, ThrowOnError> => (options.client ?? client).post<PublishPlatformRevisionResponses, PublishPlatformRevisionErrors, ThrowOnError>({ url: '/api/strategies/registry/{version_id}/publish', ...options });

/**
 * Draft Platform Revision
 */
export const draftPlatformRevision = <ThrowOnError extends boolean = false>(options: Options<DraftPlatformRevisionData, ThrowOnError>): RequestResult<DraftPlatformRevisionResponses, DraftPlatformRevisionErrors, ThrowOnError> => (options.client ?? client).post<DraftPlatformRevisionResponses, DraftPlatformRevisionErrors, ThrowOnError>({
    url: '/api/strategies/registry/{version_id}/revisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Score Policy
 */
export const readScorePolicy = <ThrowOnError extends boolean = false>(options?: Options<ReadScorePolicyData, ThrowOnError>): RequestResult<ReadScorePolicyResponses, ReadScorePolicyErrors, ThrowOnError> => (options?.client ?? client).get<ReadScorePolicyResponses, ReadScorePolicyErrors, ThrowOnError>({ url: '/api/strategies/score', ...options });

/**
 * Read Score Policy Diff
 */
export const readScorePolicyDiff = <ThrowOnError extends boolean = false>(options: Options<ReadScorePolicyDiffData, ThrowOnError>): RequestResult<ReadScorePolicyDiffResponses, ReadScorePolicyDiffErrors, ThrowOnError> => (options.client ?? client).get<ReadScorePolicyDiffResponses, ReadScorePolicyDiffErrors, ThrowOnError>({ url: '/api/strategies/score/diff', ...options });

/**
 * Read Score Decision Explanation
 */
export const readScoreDecisionExplanation = <ThrowOnError extends boolean = false>(options: Options<ReadScoreDecisionExplanationData, ThrowOnError>): RequestResult<ReadScoreDecisionExplanationResponses, ReadScoreDecisionExplanationErrors, ThrowOnError> => (options.client ?? client).get<ReadScoreDecisionExplanationResponses, ReadScoreDecisionExplanationErrors, ThrowOnError>({ url: '/api/strategies/score/explain/{cycle_id}', ...options });

/**
 * Read Score Policy History
 */
export const readScorePolicyHistory = <ThrowOnError extends boolean = false>(options?: Options<ReadScorePolicyHistoryData, ThrowOnError>): RequestResult<ReadScorePolicyHistoryResponses, ReadScorePolicyHistoryErrors, ThrowOnError> => (options?.client ?? client).get<ReadScorePolicyHistoryResponses, ReadScorePolicyHistoryErrors, ThrowOnError>({ url: '/api/strategies/score/history', ...options });

/**
 * Read Score Recommendations
 */
export const readScoreRecommendations = <ThrowOnError extends boolean = false>(options?: Options<ReadScoreRecommendationsData, ThrowOnError>): RequestResult<ReadScoreRecommendationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadScoreRecommendationsResponses, unknown, ThrowOnError>({ url: '/api/strategies/score/recommendations', ...options });

/**
 * Read Same Entry Simulator Experiment
 */
export const readSameEntrySimulatorExperiment = <ThrowOnError extends boolean = false>(options: Options<ReadSameEntrySimulatorExperimentData, ThrowOnError>): RequestResult<ReadSameEntrySimulatorExperimentResponses, ReadSameEntrySimulatorExperimentErrors, ThrowOnError> => (options.client ?? client).get<ReadSameEntrySimulatorExperimentResponses, ReadSameEntrySimulatorExperimentErrors, ThrowOnError>({ url: '/api/strategies/simulator/experiments/{experiment_id}', ...options });

/**
 * Read Strategy Workspace
 */
export const readStrategyWorkspace = <ThrowOnError extends boolean = false>(options?: Options<ReadStrategyWorkspaceData, ThrowOnError>): RequestResult<ReadStrategyWorkspaceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadStrategyWorkspaceResponses, unknown, ThrowOnError>({ url: '/api/strategies/workspace', ...options });

/**
 * Read Strategy Allocations
 */
export const readStrategyAllocations = <ThrowOnError extends boolean = false>(options?: Options<ReadStrategyAllocationsData, ThrowOnError>): RequestResult<ReadStrategyAllocationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadStrategyAllocationsResponses, unknown, ThrowOnError>({ url: '/api/strategies/workspace/allocations', ...options });

/**
 * Assign Strategy Allocation
 */
export const assignStrategyAllocation = <ThrowOnError extends boolean = false>(options: Options<AssignStrategyAllocationData, ThrowOnError>): RequestResult<AssignStrategyAllocationResponses, AssignStrategyAllocationErrors, ThrowOnError> => (options.client ?? client).post<AssignStrategyAllocationResponses, AssignStrategyAllocationErrors, ThrowOnError>({
    url: '/api/strategies/workspace/allocations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate Strategy Allocation
 */
export const activateStrategyAllocation = <ThrowOnError extends boolean = false>(options: Options<ActivateStrategyAllocationData, ThrowOnError>): RequestResult<ActivateStrategyAllocationResponses, ActivateStrategyAllocationErrors, ThrowOnError> => (options.client ?? client).post<ActivateStrategyAllocationResponses, ActivateStrategyAllocationErrors, ThrowOnError>({
    url: '/api/strategies/workspace/allocations/{allocation_id}/activation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Govern Strategy Version
 */
export const governStrategyVersion = <ThrowOnError extends boolean = false>(options: Options<GovernStrategyVersionData, ThrowOnError>): RequestResult<GovernStrategyVersionResponses, GovernStrategyVersionErrors, ThrowOnError> => (options.client ?? client).post<GovernStrategyVersionResponses, GovernStrategyVersionErrors, ThrowOnError>({
    url: '/api/strategies/workspace/versions/{version_id}/governance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Whether anything is stopping the strategy
 *
 * One snapshot of the machine, taken at one moment.
 */
export const readSystem = <ThrowOnError extends boolean = false>(options?: Options<ReadSystemData, ThrowOnError>): RequestResult<ReadSystemResponses, ReadSystemErrors, ThrowOnError> => (options?.client ?? client).get<ReadSystemResponses, ReadSystemErrors, ThrowOnError>({ url: '/api/system', ...options });

/**
 * Read Summary
 */
export const readReleaseConformance = <ThrowOnError extends boolean = false>(options?: Options<ReadReleaseConformanceData, ThrowOnError>): RequestResult<ReadReleaseConformanceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReadReleaseConformanceResponses, unknown, ThrowOnError>({ url: '/api/system/conformance', ...options });

/**
 * Run Quick
 */
export const runQuickConformance = <ThrowOnError extends boolean = false>(options?: Options<RunQuickConformanceData, ThrowOnError>): RequestResult<RunQuickConformanceResponses, unknown, ThrowOnError> => (options?.client ?? client).post<RunQuickConformanceResponses, unknown, ThrowOnError>({ url: '/api/system/conformance/quick', ...options });

/**
 * List Runs
 */
export const listConformanceRuns = <ThrowOnError extends boolean = false>(options?: Options<ListConformanceRunsData, ThrowOnError>): RequestResult<ListConformanceRunsResponses, ListConformanceRunsErrors, ThrowOnError> => (options?.client ?? client).get<ListConformanceRunsResponses, ListConformanceRunsErrors, ThrowOnError>({ url: '/api/system/conformance/runs', ...options });

/**
 * Start Full
 */
export const startFullConformance = <ThrowOnError extends boolean = false>(options?: Options<StartFullConformanceData, ThrowOnError>): RequestResult<StartFullConformanceResponses, unknown, ThrowOnError> => (options?.client ?? client).post<StartFullConformanceResponses, unknown, ThrowOnError>({ url: '/api/system/conformance/runs', ...options });

/**
 * Read Run
 */
export const readConformanceRun = <ThrowOnError extends boolean = false>(options: Options<ReadConformanceRunData, ThrowOnError>): RequestResult<ReadConformanceRunResponses, ReadConformanceRunErrors, ThrowOnError> => (options.client ?? client).get<ReadConformanceRunResponses, ReadConformanceRunErrors, ThrowOnError>({ url: '/api/system/conformance/runs/{run_id}', ...options });

/**
 * Read Release Status
 */
export const readReleaseStatus = <ThrowOnError extends boolean = false>(options?: Options<ReadReleaseStatusData, ThrowOnError>): RequestResult<ReadReleaseStatusResponses, ReadReleaseStatusErrors, ThrowOnError> => (options?.client ?? client).get<ReadReleaseStatusResponses, ReadReleaseStatusErrors, ThrowOnError>({ url: '/api/system/release-status', ...options });

/**
 * Live
 */
export const healthLive = <ThrowOnError extends boolean = false>(options?: Options<HealthLiveData, ThrowOnError>): RequestResult<HealthLiveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthLiveResponses, unknown, ThrowOnError>({ url: '/health/live', ...options });

/**
 * Ready
 */
export const healthReady = <ThrowOnError extends boolean = false>(options?: Options<HealthReadyData, ThrowOnError>): RequestResult<HealthReadyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthReadyResponses, unknown, ThrowOnError>({ url: '/health/ready', ...options });

/**
 * Safe
 */
export const healthSafe = <ThrowOnError extends boolean = false>(options?: Options<HealthSafeData, ThrowOnError>): RequestResult<HealthSafeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthSafeResponses, unknown, ThrowOnError>({ url: '/health/safe', ...options });
